import { useEffect } from "react";
import "./Domains.css";
import {
  FaCalendarAlt,
  FaShoppingCart,
  FaBuilding,
  FaWarehouse,
  FaHardHat,
  FaSchool,
} from "react-icons/fa";

export default function Domains() {
  const domaines = [
    {
      title: "Chantiers BTP & Travaux",
      desc: "Surveillance nocturne, protection contre le vol de cuivre et dégradations d'engins.",
      icon: <FaHardHat />,
    },
    {
      title: "Entrepôts & Sites Industriels",
      desc: "Gardiennage cynophile, contrôle d'accès poids lourds et rondes de fermeture.",
      icon: <FaWarehouse />,
    },
    {
      title: "Grande Distribution & Commerces",
      desc: "Prévention des démarques, filtrage entrée/sortie et sécurisation des galeries.",
      icon: <FaShoppingCart />,
    },
    {
      title: "Événementiel & Salons",
      desc: "Accueil, palpations, gestion de flux de foule lors de concerts, festivals et salons.",
      icon: <FaCalendarAlt />,
    },
    {
      title: "Résidences & Copropriétés",
      desc: "Surveillance d'accès, tranquillité résidentielle, parkings souterrains et conciergerie de sûreté.",
      icon: <FaBuilding />,
    },
    {
      title: "Établissements & Tertiaire",
      desc: "Protection de sièges sociaux, campus scolaires, centres de santé et espaces publics.",
      icon: <FaSchool />,
    },
  ];

  useEffect(() => {
    const cards = document.querySelectorAll(".domain-card");
    if (typeof IntersectionObserver === "undefined") {
      cards.forEach((card) => card.classList.add("visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        }),
      { threshold: 0.1 }
    );
    cards.forEach((card) => observer.observe(card));

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section id="domaines" className="section domaines-section">
      <div className="domaines-header">
        <span className="section-tag">{"//"} ENVIRONNEMENTS PROTÉGÉS</span>
        <h2 className="section-title">Domaines d’Intervention</h2>
        <p className="section-subtitle">
          Nos équipes adaptent leurs consignes de surveillance aux contraintes techniques et réglementaires de chaque site.
        </p>
      </div>

      <div className="domaines-grid">
        {domaines.map((d, index) => (
          <div key={index} className="domain-card">
            <div className="domain-icon-wrap">{d.icon}</div>
            <div className="domain-content">
              <h3>{d.title}</h3>
              <p>{d.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
